// removed by extract-text-webpack-plugin
module.exports = {"signout":"SignoutIFrames__signout___ZFf6e"};